<template>
  <div class="hello">
<!--  <van-notice-bar
	:text="'　　　　　　　恭喜'+luckyUser.name+'获得：'+luckyUser.rewardDescribe+'　　　　　　　'"
	left-icon="volume-o"
	v-if="luckyUser.name"
	/> -->

	<van-collapse v-model='indexs' accordion v-for="item in jianglistdata"  @change='numbtn'>
	  <van-collapse-item :title="item.rewardLevel" :name="item.id">
		  <div v-if="status">该奖项暂未抽取</div>
		  <div v-for="item in persondata" v-else>
			  <div class="deng">
			  	<span class="dengT">{{item.name}}({{item.workNumber}})</span>
			  	<span class="dengC">{{item.rewardDescribe}}</span>
			  </div>
		  </div>
		  
	  </van-collapse-item>
	</van-collapse>
  </div>
</template>


<script>
import Vue from 'vue';
import { Collapse, CollapseItem,NoticeBar,Notify } from 'vant';

Vue.use(Collapse).use(CollapseItem).use(NoticeBar).use(Notify);
	
export default {
  name: 'HelloWorld',
  data () {
    return {
		index:1,
		jianglistdata:'',
		persondata:'',
		indexs:'',
		luckyUser:{},
		status:'',
    }
  },
  
	computed:{
		userID(){
			return localStorage.getItem("userid");//用户id
		}
	},
    methods: {
	   numbtn(a){
		   this.persondata = ''
		   this.indexs = a
		   this.axios.post('https://party.blueiec.com/annual-meeting/qyluckdraw/queryWinningThePrize',{'page':1,'limit':1000,'rewardId':a,'activityId':1,'userId':this.userID})
		   .then(res=> {
			    if(res.data.status==0){
					this.status = true
				}else{
					this.status = false
					this.persondata = res.data.page.list
			    }
				// this.status = res.data.status
				// this.persondata = res.data.page.list
				
				// if(res.data.luckyUser){
				// 	console.log('res.data.luckyUser',res.data.luckyUser)
				// 	this.luckyUser = res.data.luckyUser
				// }
				   
		   })

	   },
		  JiangZhan(data){
			  this.index = data
		  },
		  meetjianglist(){
			this.axios.post('https://party.blueiec.com/annual-meeting/qyreward/queryParentId',{'activityId':1,'parentId':0})
			.then(res=> {
				this.jianglistdata = res.data.list
			})
		  },
    },
	mounted(){
		this.meetjianglist()
		// this.numbtn(0);//查看自己是否中将
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.hello{
  height: calc(100vh - 2rem);
  padding-bottom: 1rem;
  overflow-y: scroll;
  box-sizing: border-box;
  margin-top: -1rem;
}
.Jiang{
	display: flex;
	flex-direction:row;
	flex-wrap: nowrap;
  justify-content: space-between;
  height:0.8rem;
  width: 94%;
  margin-left: 3%;
  line-height:0.8rem;
  font-size: 0.26rem;
  
}
.JiangT{
  text-align: left;
  flex-grow:1;
  background: #fff;
  color: #0068b6;
}
.JiangC{
  text-align: right;
  flex-grow:3;
  color: #999;
}
.JiangX{
	display: block;
}

.van-cell{
	color: #fff;
	background:none;
}
.van-cell--clickable:active{
	color: #fff;
	background:none;
}
.van-collapse-item__content{
	background:none;
}
.deng{
	display: flex;
	flex-direction:row;
	flex-wrap: nowrap;
  justify-content: space-between;
  /* height:0.8rem; */
  width: 94%;
  margin-left: 3%;
  line-height:0.8rem;
  font-size: 0.26rem;
  border-bottom:  1px solid #efefef;
  box-sizing: border-box;
}
.dengT{
  text-align: left;
  flex-grow:1;
  color: #f29600;
}
.dengC{
  text-align: right;
  flex-grow:2;
  color: #999;
}
.dengX{
	display: block;
}
.JiangContent{
	overflow: hidden;
	transition: all 0.6s;
	-moz-transition: all 0.6s;	/* Firefox 4 */
	-webkit-transition: all 0.6s;	/* Safari 和 Chrome */
	-o-transition: all 0.6s;	/* Opera */
  	border-bottom:  1px solid #0068b6;
	width: 94%;
	margin-left: 3%;
}
.luckyUser{
	text-align: center;
	font-size: 0.3rem;
	color: #fff;
	margin-top: 0.6rem;
}
</style>



// WEBPACK FOOTER //
// src/components/upload.vue